import useReactHookForm from "hooks/useReactHookForm";

import { useAppDispatch, useAppSelector } from "hooks/redux";
import { Button, Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import { questionIpInitialValues, questionIpMandatoryFields, questionIpProperties, questionIpValidationSchema } from "./helper";

import { hasLengthGreaterThanZero, hasValidValue } from "pages/entities/helper";
import { useEffect } from "react";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import { getCollegeFromStateId } from "utils/metadata-split/depedentApiFetch";
import { areArraysEqual, setReactFormValues } from "pages/configue/constants";
import { getValuesByIds } from "../helper";

export const QuestionIpFilter = ({ setSearchPayload, setOffset,clearValuesTrigger }) => {
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    questionIpInitialValues,
    questionIpValidationSchema,
    ""
  );
  const dispatch = useAppDispatch();
     const { isLoading: isLoad, data: metaData }: any = useAppSelector(
      (state) => state.metadataReducer
    );

    const updateMetaData = async (listData, metaKey) => {
      let metadataList = { ...metaData };
      metadataList[metaKey] = listData;
      await dispatch(metadataSuccess(metadataList));
      if (metaKey == "college_list" && listData?.length == 0) {
        setValue("college_id","");
      }
    };

  const clearFilter = () => {
    setValue("state_id", "");
    setValue("college_id", "");
    setValue("ipAddress", "");
    setValue("status", "");
    setValue("expiry_from", "");
    setValue("expiry_to", "");
    setSearchPayload({});
    setOffset(0);
  };

  const handleSearch = () => {
    const payload = {
      stateId: watch()?.state_id,
      collegeObjectId: watch()?.college_id,
      ipAddress: watch()?.ipAddress,
      status: watch()?.status,
      expiryFrom: watch()?.expiry_from,
      expiryTo: watch()?.expiry_to,
    };
    setSearchPayload(payload);
    setOffset(0);
  };

    useEffect(() => {
      (async () => {
        await getCollegeFromStateId(watch()?.state_id, updateMetaData);
      })();
    }, [watch()?.state_id]);
  
      useEffect(() => {
      if (metaData?.college_list?.length > 0 && !isLoad) {
        let matchedVales = setReactFormValues(
          metaData,
          "college_list",
          watch()?.college_id,
          "college_id"
        );
        let isEqual = areArraysEqual(watch()?.college_id, matchedVales);
        if (!isEqual) {
          setValue("college_id", matchedVales);
        }
      }
    }, [metaData?.college_list]);

  useEffect(() => {
    clearFilter();
  }, [clearValuesTrigger]);

  return (
    <div>
      <Paper elevation={2} sx={{ px: 2, pb: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={questionIpProperties}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
          <ContentRight sx={{ mt: -7 }}>
            <Button
              variant="contained"
              sx={{
                width: "70px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={clearFilter}
            >
              clear
            </Button>
            <Button
              variant="contained"
              sx={{
                width: "80px",
                height: "40px",
                marginTop: "15px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleSearch}
            >
              search
            </Button>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
};
